import React, { Component } from 'react';
import Form from '../../../lib/ui/form';
import { Row, Button, notification, Spin } from 'antd';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { showErrorInNotification } from '../../../lib/util';
import ErrorWrapper from '../../../lib/error_wrapper';


const bank_info_schema = [
  {
    name: "Company Name",
    index: 'name',
    type: 'text',
    required:true
  },
  {
    name: "Address",
    index: 'address',
    type: 'text',
  },

  {
    name: "Phone Number",
    index: 'phone_number',
    type: 'text',
  }
]

class BasicInformation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      form_data: {}
    }

    this.get_setting = RESTExecutor.detail().config({
      label: 'basic_setting'
    }).callbacks((success) => {
      this.setState({ form_data: (success.result) || {} });
    }, (error) => {
      console.log("error", error);
      showErrorInNotification(error)
    }).connect(props.domains.appSetting);

    this.set_setting = RESTExecutor.post().config({
      label: 'basic_setting'
    }).callbacks((success) => {
      console.log("success", success);
      notification.success({
        message:"Information  Updated"
      })
    }, (error) => {
      console.log("error", error);
      showErrorInNotification(error);
    }).connect(props.domains.appSetting);

    this.get_setting.execute();
  }

  updateSetting = () => {
    let data = JSON.parse(JSON.stringify(this.state.form_data));
    let sending_data = data;
    // Object.keys(data).map((key) => {
    //   let value = data[key];
    //   sending_data[key] = {
    //     "user_hierarchy": value
    //   }
    // });
    console.log("sending data", sending_data)

    this.set_setting.execute(sending_data)


  }

render() {
    let set_setting_resp = this.set_setting.response();
    let get_setting_resp=this.get_setting.response();
    if(get_setting_resp.fetching){
        return <center><Spin/></center>
    }
    return (
      <div>
         <ErrorWrapper
          error={get_setting_resp}
          onReload={()=>{
              this.get_setting.execute();
          }}
          >
        <Form
          hideTitle
          forCreate={true}
          initialData={this.state.form_data || {}}
          submitted={this.state.submitted}
          onChange={(data) => {
            this.setState({ form_data: data })
          }}
          fields={bank_info_schema}
          submitting={{}}
          errorMessage={set_setting_resp.error_message}
          validationErrors={set_setting_resp.validation_errors}
        />
        <br></br>
        <Row type='flex' justify='end'>
          <Button type='primary'
            disabled={set_setting_resp.fetching}
            loading={set_setting_resp.fetching}
            onClick={() => {
              this.setState({submitted: true});
              this.updateSetting()
            }}
          >Submit</Button>
        </Row>
        </ErrorWrapper>

      </div>
  );
}
}

export default withDomains(BasicInformation,"appSetting");
